@if (canManage) {
  <section class="panel access-panel">
    <div class="section-header">
      <h3>Access</h3>
      @if (loading) {
        <span class="muted">Checking…</span>
      } @else if (current) {
        <span class="pill pill-red">Under maintenance</span>
      } @else if (!unavailable) {
        <span class="pill pill-green">Open</span>
      }
    </div>

    @if (unavailable) {
      <div class="muted">{{ unavailable }}</div>
    } @else {
      @if (current; as c) {
        <div class="access-facts">
          <div>Closed since {{ utc(c.startedAtUtc) | date:'d MMM y, HH:mm' }} by {{ c.startedBy || '—' }}.</div>
          @if (c.expectedEndUtc) { <div>Expected back {{ utc(c.expectedEndUtc) | date:'d MMM y, HH:mm' }}.</div> }
          <div class="access-message">Merchants read: “{{ c.message || defaultMessage }}”</div>
          <div class="muted">Every till, phone and website order for this business is stopped until you lift it. Nothing lifts on its own.</div>
        </div>
      } @else {
        <div class="muted">Tills, phones and website orders are working normally. Putting the business under maintenance shows them a maintenance page until you lift it; other businesses are not affected.</div>
      }

      @if (notice) { <div class="note note-ok">{{ notice }}</div> }
      @if (error) { <div class="note note-err">{{ error }}</div> }

      <ng-container *staffCan="'Platform.Maintenance.Manage'">
        @if (!formOpen && !liftAsking) {
          <div class="access-actions">
            @if (current) {
              <button type="button" class="act-ghost act-sm" [disabled]="saving || !editing" (click)="openForm()">Change words…</button>
              <button type="button" class="act act-sm" [disabled]="saving || !editing" (click)="askLift()">Lift maintenance…</button>
            } @else {
              <button type="button" class="act-danger act-sm" [disabled]="saving || !editing" (click)="openForm()">Put under maintenance…</button>
            }
            @if (!editing) { <span class="muted small">Press Edit above to change access.</span> }
          </div>
        }

        @if (formOpen) {
          <div class="note note-warn access-form">
            @if (current) {
              Change what <strong>{{ businessName || businessId }}</strong> shows while it is under maintenance.
            } @else {
              Put <strong>{{ businessName || businessId }}</strong> under maintenance? Its tills, phones and website orders stop until you lift it.
            }
            <div class="form-grid access-fields">
              <label class="field access-field-wide">
                <span>What merchants read (blank uses the standard wording)</span>
                <textarea class="inp" rows="3" [(ngModel)]="message" [maxlength]="messageMax" [placeholder]="defaultMessage" [disabled]="saving"></textarea>
                <span class="muted small">{{ message.length }}/{{ messageMax }}</span>
              </label>
              <label class="field">
                <span>Expected back (optional, your local time)</span>
                <input class="inp" type="datetime-local" [(ngModel)]="expectedEndLocal" [disabled]="saving" />
                @if (expectedEndError) { <span class="form-error">{{ expectedEndError }}</span> }
              </label>
            </div>
            <div class="confirm-actions">
              <button type="button" class="act-ghost act-sm" [disabled]="saving" (click)="cancelForm()">Cancel</button>
              <button type="button" [class]="(current ? 'act' : 'act-danger') + ' act-sm'" [disabled]="saving || !!expectedEndError" (click)="confirmForm()">
                {{ saving ? 'Saving…' : current ? 'Save words' : 'Yes, put this business under maintenance' }}
              </button>
            </div>
          </div>
        }

        @if (liftAsking) {
          <div class="note note-warn access-form">
            Lift maintenance for <strong>{{ businessName || businessId }}</strong>? Its tills and phones go straight back in.
            <div class="confirm-actions">
              <button type="button" class="act-ghost act-sm" [disabled]="saving" (click)="cancelLift()">Keep closed</button>
              <button type="button" class="act act-sm" [disabled]="saving" (click)="confirmLift()">{{ saving ? 'Saving…' : 'Yes, lift it' }}</button>
            </div>
          </div>
        }
      </ng-container>
    }
  </section>
}
